import { jsx as p } from "react/jsx-runtime";
import { createContext as l, useState as v, useLayoutEffect as w, useEffect as y, useContext as T } from "react";
import "isomorphic-dompurify";
import { a as E } from "./theme-DOVZ7zBr.js";
import { w as k } from "./deprecation-Hz1LRzMC.js";
function L(e, n) {
  return n.domains[e] ? { ...n.defaultTheme, ...n.domains[e] } : n.defaultTheme;
}
function x(e) {
  return typeof window > "u" ? void 0 : L(window.location.hostname, e);
}
const c = l(void 0), i = typeof window < "u" ? w : y, a = (e, n) => e === "system" || !e ? n ? "dark" : "light" : e;
function F({
  children: e,
  defaultTheme: n = {},
  domainConfig: s,
  initialTheme: d
}) {
  d && k({
    name: "ThemeProvider",
    key: "initialTheme",
    type: "prop",
    replacement: "defaultTheme"
  });
  const [o, u] = v(() => {
    if (s) {
      const t = x(s);
      if (t)
        return t;
    }
    return d || n;
  }), f = (t) => {
    u((r) => ({ ...r, ...t }));
  };
  return i(() => {
    if (typeof window > "u") return;
    const t = window.matchMedia("(prefers-color-scheme: dark)"), r = () => {
      const m = a(o.mode, t.matches), h = { ...o, mode: m };
      E(h);
    };
    if (r(), o.mode === "system" || !o.mode)
      return t.addEventListener("change", r), () => t.removeEventListener("change", r);
  }, [o]), i(() => {
    if (typeof window > "u") return;
    const t = window.matchMedia("(prefers-color-scheme: dark)"), r = () => {
      const m = a(o.mode, t.matches);
      document.documentElement.classList.toggle("dark", m === "dark");
    };
    if (r(), o.mode === "system" || !o.mode)
      return t.addEventListener("change", r), () => {
        t.removeEventListener("change", r);
      };
  }, [o.mode]), i(() => () => {
    document.documentElement.classList.remove("dark");
  }, []), /* @__PURE__ */ p(c.Provider, { value: { theme: o, setTheme: f }, children: e });
}
function Q() {
  const e = T(c);
  if (e === void 0)
    throw new Error("useTheme must be used within a ThemeProvider");
  return e;
}
export {
  F as T,
  x as i,
  L as r,
  Q as u
};
